import axios from 'axios';

export const anonymous = () => axios.post('https://smartmap.at/api/anonymous');

export const login = (username: string, password: string) => axios.post('https://smartmap.at/api/authentication', {
  email: username,
  password,
  strategy: 'local',
});

export const changePassword = (username: string, oldPassword: string, password: string) =>
  axios.post('https://smartmap.at/api/authManagement', {
    action: 'passwordChange',
    value: {
      email: username,
      oldPassword,
      password,
      user: {
        email: username,
      },
    },
  });
